

export function pluralize(label, count) {
  label = count === 1 ? label : `${label}s`;
  return `${count} ${label}`;
}



// WEBPACK FOOTER //
// ./assets/es6/common/utils.es6